module.exports = __webpack_public_path__ + "static/media/pic3.695d82f1.jpg";